import { IonIcon } from '@ionic/react'
import React, { FC } from 'react'

interface CardIconProps {
	icon?: string
	star?: boolean
	iconStyle?: string
}

const ScoreboardCardIcon: FC<CardIconProps> = ({ icon, star, iconStyle }) => (
	<div className='h-8 aspect-square flex items-center justify-center'>
		{star ? (
			<img src='assets/star-yellow.svg' className='h-7 w-7' alt='Star' />
		) : icon ? (
			<IonIcon icon={icon} className={`h-7 w-7 [--ionicon-stroke-width:48px] ${iconStyle || ''}`} />
		) : null}
	</div>
)

export default ScoreboardCardIcon
